import Vue from 'vue'
import VueFilterPrettyBytes from 'vue-filter-pretty-bytes'

Vue.use(VueFilterPrettyBytes)
